function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "paperplane"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.941 10.211-16.421-8.211c-.999-.499-1.928-.354-2.424.313-.248.333-.484.931-.197 1.89l1.852 6.168c.26.867.26 2.391 0 3.258l-1.852 6.168c-.287.959-.052 1.558.196 1.891.296.396.75.615 1.278.615.357 0 .743-.102 1.146-.303l16.422-8.211c.82-.41 1.291-1.063 1.291-1.789s-.47-1.379-1.291-1.789zm-17.036 9.86 1.762-5.868c.106-.353.178-.767.224-1.203h8.393c.553 0 1-.447 1-1s-.447-1-1-1h-8.393c-.046-.436-.117-.85-.224-1.203l-1.762-5.868 16.142 8.071z"
}));

var Svg088Send = function Svg088Send(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg088Send, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/088-send.3d16ef27.svg";
export { ForwardRef as ReactComponent };